import React from 'react'
import './infoAdicional.css'
import { WhatsButton } from '../../components';
import parse from "html-react-parser";
import pt from "../../locales/pt.json";

// vê se tem como melhorar/otimizar o esquema do efeito do fundo desse aqui
const InfoAdicional = () => {
  return (
    <div className="psico__infoAdicional">
      <div className="psico__infoAdicional-content">
        <h1><b>{pt.infoAdicional.title}</b></h1><br />
        {/* <p>Está pronto?</p> */}
      </div>
      <div className="psico__infoAdicional-add">
        {/* <p>Aproveite o Valor Promocional (Vagas limitadas) - <a href="#infos"><u>Veja o valor nas Informações.</u></a></p><br /> */}
        {/* <p>Encare seus desafios com confiança e construa o bem-estar que você merece.</p>
        <p>A decisão está nas suas mãos – comece hoje mesmo!</p>
        <p>Está pronto para iniciar sua jornada?</p><br /> */}
        <p>{parse(pt.infoAdicional.subtitle)}</p>
      </div>
      <div className="psico__infoAdicional-button">
        <WhatsButton message={pt.whatsButton.escolha} />
      </div>
    </div>
  )
}

export default InfoAdicional
